export function isIJsonArray(o) {
    return Array.isArray(o);
}
export function isIJsonObject(o) {
    return o !== null && typeof o === 'object' && !Array.isArray(o);
}
export { isIJsonObject as isIObject, isIJsonArray as isIArray, };
//# sourceMappingURL=Json.js.map